import { COUNT_GST, EDIT_WORK_ORDER_STATUS, QUOTATION_DROPDOWN, QUOTATION_WORK_ORDER, WORK_ORDER, WORK_ORDER_EDIT, WORK_ORDER_LIST } from "./ApiRoutes";
import { authData } from "./services";

export const addWorkOrderApi = async (data: object) => {
  const response = await authData.post(WORK_ORDER, data);
  return response?.data;
};
export const listOfWorkOrderApi = async (data: object) => {
  const response = await authData.post(WORK_ORDER_LIST, data);
  return response?.data;
};
export const quotationDropdownApi = async (data: object) => {
  const response = await authData.post(QUOTATION_DROPDOWN, data);
  return response?.data;
};
export const viewWorkOrderApi = async (id: number) => {
  const response = await authData.get(`${WORK_ORDER_EDIT}${id}`);
  return response?.data;
};
export const editWorkOrderApi = async (id:number, data: object) => {
  const response = await authData.put(`${WORK_ORDER_EDIT}${id}`, data);
  return response?.data;
};
export const deleteWorkOrderApi = async (id: number) => {
  const response = await authData.delete(`${WORK_ORDER_EDIT}${id}`);
  return response?.data;
};
export const calculateGstApi = async (data:any) => {
  const response = await authData.post(COUNT_GST, data);
  return response?.data;
}
export const quotationWorkOrderApi = async () => {
  const response = await authData.get(QUOTATION_WORK_ORDER);
  return response?.data;
}
export const editWorkOrderStatusApi = async (id:number, data: object) => {
  const response = await authData.put(`${EDIT_WORK_ORDER_STATUS}${id}`, data);
  return response?.data;
};